import React from 'react';
import { compose, reject, isNil, defaultTo, prop, not, isEmpty, find, propEq, propOr } from 'ramda';
import { Button, Table } from 'antd';
import { Link } from 'react-router-dom';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Components } from '@fasstech/flexiget';
import ConfirmButton from '../../../../components/ConfirmButton';
import useActionGuard from '../../../../hooks/useActionGuard';
import TableDates from './TableDates';

const TagsTable = ({ tags, userCanEditOffer, onClickEdit, onClickDelete, getLink, reFetch }) => {
  const { loading, run } = useActionGuard();

  tags = compose(
    reject(isNil),
    defaultTo([])
  )(tags);

  return (
    <Table
      size="small"
      dataSource={tags}
      rowKey="id"
      pagination={false}
      locale={{ emptyText: 'Aucune donnée' }}
    >
      <Table.Column
        title="Nom"
        dataIndex="name"
        defaultSortOrder="ascend"
        width={300}
        sorter={(a, b) => prop('name', a).toLowerCase().localeCompare(prop('name', b).toLowerCase())}
        render={(name, tag) => <Link to={getLink(tag)}>{name}</Link>}
      />

      <Table.Column
        title="Type"
        dataIndex="itemType"
        width={300}
        render={(type) => (
          <span className="capitalize">{type}</span>
        )}
      />

      {TableDates}

      <Table.Column
        title=""
        dataIndex="id"
        render={(tagId) => {
          if (userCanEditOffer) {
            const currentTag = find(propEq(tagId, 'id'), tags);
            const isTagUsed = compose(
              not,
              isEmpty,
              prop('itemsIds')
            )(currentTag);
            const isDefaultTag = propOr(false, 'isDefault', currentTag);
            const isDisabled = isTagUsed || isDefaultTag;

            return (
              <div className="flex justify-end gap-2 text-lg">
                <Components.Tooltip
                  title="Éditer le tag"
                >
                  <Button
                    icon={<EditOutlined className="hover:text-flexi-grey" />}
                    className="btn-edit-tag"
                    onClick={() => onClickEdit(tagId)}
                    type="text"
                  />
                </Components.Tooltip>
                <Components.Tooltip
                  title={
                    isDisabled
                      ? 'Ce tag est utilisé, vous ne pouvez pas le supprimer.'
                      : 'Supprimer le tag'
                  }
                >
                  <ConfirmButton
                    title="Êtes-vous sûr de vouloir supprimer ce tag ?"
                    onConfirm={() => run(`remove-tag-${tagId}`, (done) => onClickDelete(tagId, (ok, error) => {
                      reFetch();
                      done(ok, error);
                    }))}
                    disabled={isDisabled}
                    icon={<DeleteOutlined className="btn-remove-tag hover:text-flexi-red"/>}
                    buttonType="text"
                    loading={propOr(false, `remove-tag-${tagId}`, loading)}
                  />
                </Components.Tooltip>
              </div>
            );
          }
          return null;
        }}
      />
    </Table>
  );
};

export default TagsTable;
